module.exports = __webpack_public_path__ + "media/images/football-985d3238b8e67ed9ac4d9286de17b87b.png";